'use client'

import { ExchangeAndReturns } from '@/screens/Return'

import { InfoPageLayout } from '@/shared/lib/layouts/InfoPageLayout'

const ReturnPageContent = () => {
	return (
		<>
			<InfoPageLayout>
				<ExchangeAndReturns />
			</InfoPageLayout>
		</>
	)
}

export function ReturnClient() {
	return <ReturnPageContent />
}
